module.exports = __webpack_public_path__ + "assets/54d06ce7f6e3a6c2305349f56c94130d.mp4";